import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '../translations';

Vue.use(VueI18n);

// eslint-disable-next-line import/prefer-default-export
export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
});
